import { useEffect, useState } from "react"
import oktaAuth from "../Model/oktaAuthSingleton"
import styles from "./SignOut.module.css"

const SignOut = () => {
    const [username, setUsername] = useState<string | null>(null)

    useEffect(() => {
        const fetchUserName = async () => {
            try {
                const user = await oktaAuth.getUser()
                setUsername(user.name ?? null) // Use null if user.name is undefined
            } catch (error) {
                console.error("Error fetching user information:", error)
                setUsername(null)
            }
        }

        fetchUserName()
    }, [])

    const logout = async () => {
        oktaAuth.tokenManager.clear()
        await oktaAuth.signOut()
    }

    return (
        <div className={styles.link} onClick={logout}>
            {username ? `Sign Out (${username})` : "Sign Out"}
        </div>
    )
}

export default SignOut
